import React from "react";
import TableBody from "@material-ui/core/TableBody";
import Skeleton from "@material-ui/lab/Skeleton";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

interface TableBodySkeletonProps {
  rows: number;
  cols: number;
}

export function TableBodySkeleton({ rows, cols }: TableBodySkeletonProps) {
  return (
    <TableBody>
      {Array(rows)
        .fill(undefined)
        .map((_, i) => {
          const key = `${i}${rows}${cols}`;
          return (
            <TableRow key={key}>
              <TableCell colSpan={cols}>
                <Skeleton height={40} />
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  );
}
